import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'vnetwork-ui'
import { tabs } from './tab'

const WorkDayManage = () => {
    const { t } = useTranslation()

    const { TabComponent, TabProps } = useTabs({
        tabs: tabs(),
    })

    return (
        <div>
            <SubHeaders
                actions={[]}
                components={[]}
                breadcrumbs={[
                    {
                        path: paths.workdayManage,
                        title: t('workday-manage'),
                    },
                ]}
            />
            <div className="space-y-2">
                <Tabs {...TabProps} />
                {TabComponent}
            </div>
        </div>
    )
}

export default WorkDayManage
